module.exports = __webpack_public_path__ + "img/you.a9a1e35d.png";